/* Hidden layout checker. Only runs when the page URL contains ?uvbcheck
   Lists anything wider than the screen (the cause of zoom-out on mobile Chrome). */
(function () {
  if (window.location.search.indexOf('uvbcheck') === -1) return;
  function clipped(el) {
    var p = el.parentElement;
    while (p && p !== document.body) {
      var ox = getComputedStyle(p).overflowX;
      if (ox === 'hidden' || ox === 'auto' || ox === 'scroll' || ox === 'clip') return true;
      p = p.parentElement;
    }
    return false;
  }
  function name(el) {
    var s = el.tagName.toLowerCase();
    if (el.id) s += '#' + el.id;
    if (el.classList.length) s += '.' + Array.prototype.slice.call(el.classList, 0, 3).join('.');
    var sec = el.closest('.shopify-section');
    if (sec && sec.id) s += '  [' + sec.id.replace('shopify-section-template--', '').replace(/^shopify-section-/, '') + ']';
    return s;
  }
  function run() {
    var vw = document.documentElement.clientWidth;
    var found = [];
    document.querySelectorAll('body *').forEach(function (el) {
      var cs = getComputedStyle(el);
      if (cs.display === 'none' || cs.visibility === 'hidden') return;
      var r = el.getBoundingClientRect();
      if (!r.width) return;
      var fixed = cs.position === 'fixed';
      if ((r.right > vw + 1 || r.left < -1) && (fixed || !clipped(el))) {
        found.push({ el: el, txt: name(el) + '  L' + Math.round(r.left) + ' R' + Math.round(r.right) + (fixed ? ' (fixed)' : '') });
      }
    });
    var box = document.createElement('div');
    box.style.cssText = 'position:fixed;left:8px;right:8px;bottom:8px;max-height:45vh;overflow:auto;z-index:2147483647;background:#fff;color:#000;border:2px solid #c00;border-radius:8px;padding:10px;font:12px/1.4 monospace;';
    box.innerHTML = '<b>Screen width: ' + vw + 'px · Page width: ' + document.documentElement.scrollWidth + 'px · Too wide: ' + found.length + '</b>';
    found.slice(0, 25).forEach(function (f) {
      f.el.style.outline = '2px solid red';
      var d = document.createElement('div');
      d.textContent = f.txt;
      box.appendChild(d);
    });
    document.body.appendChild(box);
  }
  window.addEventListener('load', function () { setTimeout(run, 1500); });
})();
